/*
 * Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { clearPendingCopilotPrompt } from './copilotPrompt';
import { clearPendingExploreIntegrations } from './exploreIntegrationsIntent';
import { clearPendingPrebuiltIntegration } from './prebuiltIntegrationIntent';

/**
 * Revokes both of the login page's parked intents at once.
 *
 * A typed Copilot prompt and an Explore integrations press — with or without a
 * prebuilt integration picked from the landing page — each outlive the
 * page that set them: the dialog can be abandoned with the browser Back button
 * rather than closed, which leaves the marker behind with nothing left to
 * spend it. Every destination that is not itself acting on one of the two
 * calls this, so neither can resurface within its TTL and divert a later sign
 * in — or the next organization created on this device — somewhere nobody
 * asked for.
 *
 * The one place that must not use this is the Copilot hand-over, which drops
 * the outranked Explore integrations intent while deliberately keeping the
 * prompt for the create integration page downstream to consume.
 */
export const clearPendingCopilotEntryPoints = () => {
  clearPendingCopilotPrompt();
  clearPendingExploreIntegrations();
  clearPendingPrebuiltIntegration();
};
